export * from "@vaadin/dashboard/vaadin-dashboard-section.js";
export * from './generated/DashboardSection.js';
